import { Component, Input } from '@angular/core';
import { Camera } from '../../models/camera.model';
import { DataFormModel } from '../../models/data-form-model.model';
import { FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CameraService } from '../../services/camera.service';
import { GateService } from '../../services/gate.service';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-camera-modal',
  templateUrl: './camera-modal.component.html',
  styleUrl: './camera-modal.component.scss'
})
export class CameraModalComponent {

  @Input() camera?: Camera;
  @Input() neighborhoodId: string = '';

  public dataForm: DataFormModel = {
    description: {
      value: '',
      type: 'text',
      label: 'Descripción',
      required: true,
      requiredMessage: 'Por favor, ingrese una descripción',
      validators: [Validators.required]
    },
    gateId: {
      value: null,
      type: 'select',
      label: 'Caseta',
      idSelect: 'gateId',
      labelSelect: 'gateName',
      data: [],
      required: false,
      placeholder: 'Sin caseta asignada',
      validators: []
    },
    hostIp: {
      value: '',
      type: 'text',
      label: 'IP del host',
      required: false,
      validators: []
    },
    hostPort: {
      value: 8001,
      type: 'number',
      label: 'Puerto del host',
      required: true,
      requiredMessage: 'Por favor, ingrese el puerto del host',
      validators: [Validators.required]
    },
    ip: {
      value: '',
      type: 'text',
      label: 'Dirección IP',
      required: true,
      requiredMessage: 'Por favor, ingrese la IP',
      validators: [Validators.required]
    },
    username: {
      value: '',
      type: 'text',
      label: 'Usuario',
      required: true,
      requiredMessage: 'Por favor, ingrese el usuario',
      validators: [Validators.required]
    },
    password: {
      value: '',
      type: 'text',
      label: 'Contraseña',
      required: true,
      requiredMessage: 'Por favor, ingrese la contraseña',
      validators: [Validators.required]
    },
    params: {
      value: '',
      type: 'text',
      label: 'Parámetros',
      required: true,
      requiredMessage: 'Por favor, ingrese los parámetros',
      validators: [Validators.required]
    },
  };

  public formCamera!: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public cameraService: CameraService,
    public gateService: GateService,
    public utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  get f() {
    return this.formCamera.controls;
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR loadData                              */
  /* -------------------------------------------------------------------------- */
  // region loadData
  async loadData() {
    this.loading = true;

    await this.gateService.getAll(this.neighborhoodId);
    this.dataForm['gateId'].data = this.gateService.gates;

    if (this.camera) {
      for (let key of Object.keys(this.dataForm)) {
        if (key in this.camera) {
          const cameraKey = key as keyof Camera;
          this.dataForm[key].value = this.camera[cameraKey]!;
        }
      }
    }

    this.formCamera = this.utilService.buildForm(this.dataForm);
    this.loading = false;
  }

  /* -------------------------------------------------------------------------- */
  /*                                 ANCHOR onSubmit                            */
  /* -------------------------------------------------------------------------- */
  // region onSubmit
  async onSubmit() {
    this.submitted = true;

    if (this.formCamera.invalid) {
      return;
    }

    if (this.camera) {
      await this.update();
    } else {
      await this.create();
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR create                               */
  /* -------------------------------------------------------------------------- */
  // region create
  async create() {
    const flag = await this.cameraService.create(
      this.neighborhoodId,
      this.formCamera.value
    );

    if (flag) {
      this.activeModal.close();
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR update                               */
  /* -------------------------------------------------------------------------- */
  // region update
  async update() {
    this.formCamera.value.cameraId = this.camera!.cameraId;
    this.formCamera.value.neighborhoodId = this.neighborhoodId;

    const flag = await this.cameraService.update(
      this.formCamera.value
    );

    if (flag) {
      this.activeModal.close();
    }
  }

}
